module.exports = __webpack_public_path__ + "images/9b92d096d4375b933ee01f24fd36754a.jpg";


//////////////////
// WEBPACK FOOTER
// ./webpack/assets/img/wheels-locations02.jpg
// module id = ./webpack/assets/img/wheels-locations02.jpg
// module chunks = 0